import { render, staticRenderFns } from "./ExperimentDes.vue?vue&type=template&id=8a98aa9c&scoped=true&"
import script from "./ExperimentDes.vue?vue&type=script&lang=js&"
export * from "./ExperimentDes.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/project-infor-2020.css?vue&type=style&index=0&id=8a98aa9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a98aa9c",
  null
  
)

export default component.exports